export const user = Object.freeze({
  basUrl: '/ucenter/user/',
  parmUrl: (id) => `/ucenter/user/${id}`,
  getUserRole: (id) => `/ucenter/user/role/${id}`,
  updateUserRole: (id) => `/ucenter/user/${id}/role`,
  getUserPrivilege: (id) => `/ucenter/user/privilege/${id}`,
  updateUserPrivilege: (id) => `/ucenter/user/${id}/privilege`,
  orgUser: '/ucenter/userInfo/list',
  addUsers: 'ucenter/user/list',
  resetPwd: (id) => `/ucenter/user/${id}/password`,
  updatePwd: '/ucenter/user/password',
  getPublicKey: '/ucenter/user/key',
  resetPwdNoToken: '/ucenter/user/init/password'
})

export const role = Object.freeze({
  basUrl: '/ucenter/sys/role/',
  parmUrl: (id) => `/ucenter/sys/role/${id}`,
  getRoleMenu: (id) => `/ucenter/sys/role/menu/${id}`,
  updateRoleMenu: (id) => `/ucenter/sys/role/${id}/menu`
})

export const menu = Object.freeze({
  basUrl: '/ucenter/sys/menu/',
  parmUrl: (id) => `/ucenter/sys/menu/${id}`
})



// WEBPACK FOOTER //
// ./src/api/authorityUrl.js